<template>
    <b-dropdown v-bind="$attrs">
        <template #button-content>
            <slot :value="value" :text="text" name="value">{{ text }}</slot>
        </template>
        <b-dropdown-item
            v-for="(option, index) in options"
            :key="index"
            :active="value === option.value"
            @click="click(option)"
        >
            <slot :option="option" name="option">{{ option.text }}</slot>
        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
export default {
    name: "SwxDropdown",
    inheritAttrs: false,
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    },
    computed: {
        text() {
            const opt = this.options.find(
                option => option.value === this.value
            );
            if (opt) {
                return opt.text;
            }
            return "";
        }
    },
    methods: {
        click(option) {
            if (option.value !== this.value) {
                this.$emit("input", option.value);
            }
        }
    }
};
</script>
